// extracted by mini-css-extract-plugin
export var container = "touchpoint-module--container--67d35";
export var customer = "touchpoint-module--customer--25374";
export var employee = "touchpoint-module--employee--cf50d";
export var logo = "touchpoint-module--logo--64fe9";
export var mainContainer = "touchpoint-module--mainContainer--1357a";
export var name = "touchpoint-module--name--9c5f4";
export var selectedTouchpoint = "touchpoint-module--selectedTouchpoint--284f9";
export var title = "touchpoint-module--title--42fd1";
export var titleName = "touchpoint-module--titleName--2a543";
export var titleSubtitle = "touchpoint-module--titleSubtitle--c4a53";
export var touchpointBack = "touchpoint-module--touchpointBack--80035";
export var touchpointBar = "touchpoint-module--touchpointBar--d7a6d";
export var touchpointBarContainer = "touchpoint-module--touchpointBarContainer--248a8";
export var touchpointBarTitle = "touchpoint-module--touchpointBarTitle--87e01";
export var touchpointIcon = "touchpoint-module--touchpointIcon--20bdc";
export var touchpointIconSelected = "touchpoint-module--touchpointIconSelected--a507d";
export var touchpointLogo = "touchpoint-module--touchpointLogo--407ca";
export var touchpointTitle = "touchpoint-module--touchpointTitle--c230d";